import { QUESTION_CONFIG_KEY } from '../../../../constants/questionConfigKeys';
import { API_STYLE_VALUE, DISPLAY_STYLE, type DisplayStyle } from '../../../../constants/displayStyles';
import { getConfigValue } from './configUtils';

export function detectDisplayStyle(
  configs: { key: string; value?: string[] }[],
  dataSubType?: string
): DisplayStyle {
  const allConfigValues = configs.map(c => c.value?.[0] || '').join(' ').toUpperCase();
  const searchString = `${allConfigValues} ${(dataSubType || '').toUpperCase()}`;

  let buttonType = getConfigValue(configs, QUESTION_CONFIG_KEY.BUTTON_TYPE)?.toLowerCase();
  if (buttonType === API_STYLE_VALUE.RADIO.toLowerCase()) {
    buttonType = DISPLAY_STYLE.STANDARD;
  }

  const knownStyles: DisplayStyle[] = [
    DISPLAY_STYLE.EMOJI,
    DISPLAY_STYLE.STAR,
    DISPLAY_STYLE.STANDARD,
    DISPLAY_STYLE.NUMBERED,
    DISPLAY_STYLE.DROPDOWN,
    DISPLAY_STYLE.SELECTBOX,
    DISPLAY_STYLE.GRAPHICS,
  ];
  if (buttonType && knownStyles.includes(buttonType as DisplayStyle)) {
    return buttonType as DisplayStyle;
  }

  if (
    searchString.includes(API_STYLE_VALUE.EMOJI) ||
    searchString.includes(API_STYLE_VALUE.CSAT) ||
    searchString.includes(API_STYLE_VALUE.SMILEY) ||
    searchString.includes(API_STYLE_VALUE.FACE)
  ) {
    return DISPLAY_STYLE.EMOJI;
  }
  if (searchString.includes(API_STYLE_VALUE.STAR)) return DISPLAY_STYLE.STAR;
  if (searchString.includes(API_STYLE_VALUE.GRAPHIC) || searchString.includes(API_STYLE_VALUE.SLIDER)) {
    return DISPLAY_STYLE.GRAPHICS;
  }
  if (searchString.includes(API_STYLE_VALUE.DROP)) return DISPLAY_STYLE.DROPDOWN;
  if (searchString.includes(API_STYLE_VALUE.SELECT)) return DISPLAY_STYLE.SELECTBOX;
  if (searchString.includes(API_STYLE_VALUE.RADIO)) return DISPLAY_STYLE.STANDARD;
  if (searchString.includes(API_STYLE_VALUE.NUMBER)) return DISPLAY_STYLE.NUMBERED;

  return DISPLAY_STYLE.STANDARD;
}
